import Splide, { Options } from '@splidejs/splide';

type ExtendedOptions = Partial<Options> & {
    disableBelow?: number;
};

function debounce(fn: Function, delay: number) {
    let timer: number | undefined;
    return (...args: any[]) => {
        if (timer) clearTimeout(timer);
        timer = window.setTimeout(() => fn(...args), delay);
    };
}

export default function splideSlider(userOptions: ExtendedOptions = {}) {
    let splide: Splide | null = null;
    let el: HTMLElement;
    let options: ExtendedOptions;

    function shouldEnableSlider(): boolean {
        return typeof options.disableBelow === 'number'
            ? window.innerWidth >= options.disableBelow
            : true;
    }

    function mountSlider() {
        if (!splide) {
            splide = new Splide(el, options);
            splide.mount();
        }
    }

    function destroySlider() {
        if (splide) {
            splide.destroy();
            splide = null;
        }

        if (el) {
            el.classList.remove('is-active', 'is-initialized');
            el.removeAttribute('style');
        }
    }

    const handleResize = debounce(() => {
        if (shouldEnableSlider()) {
            if (!splide) {
                mountSlider();
            }
        } else {
            destroySlider();
        }
    }, 150);

    return {
        init() {
            el = this.$el as HTMLElement;

            options = {
                type: 'loop',
                perPage: 3,
                gap: '1rem',
                arrows: true,
                pagination: false,
                ...userOptions,
            };

            if (shouldEnableSlider()) {
                mountSlider();
            }

            window.addEventListener('resize', handleResize);
        },

        goTo(index: number) {
            if (splide) {
                splide.go(index);
            }
        },
    };
}
